import React from "react";
import { Alert, useTheme } from "@mui/material";

const BANNER_TEXT_COLOR = "#000000";

interface InfoBannerCstProps {
  children: React.ReactNode;
  onClose?: () => void;
  sx?: Record<string, any>;
}

const InfoBannerCst: React.FC<InfoBannerCstProps> = ({
  children,
  onClose,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Alert
      severity="info"
      onClose={onClose}
      sx={{
        borderRadius: "10px",
        backgroundColor: theme.palette.badge.info.background,
        border: `1px solid ${theme.palette.badge.info.border}`,
        color: BANNER_TEXT_COLOR,
        "& .MuiAlert-icon": { color: theme.palette.badge.info.border },
        "& .MuiAlert-action .MuiIconButton-root": { color: BANNER_TEXT_COLOR },
        ...sx,
      }}
    >
      {children}
    </Alert>
  );
};

export default InfoBannerCst;
